import { render, staticRenderFns } from "./FileDropzone.vue?vue&type=template&id=6916c8ac&scoped=true"
import script from "./FileDropzone.vue?vue&type=script&lang=js"
export * from "./FileDropzone.vue?vue&type=script&lang=js"
import style0 from "./FileDropzone.vue?vue&type=style&index=0&id=6916c8ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6916c8ac",
  null
  
)

export default component.exports